import RequestCreator from './BaseRequest';
import { VisitFlowTypesModel } from '@w3lcome/types';

const api = new RequestCreator<VisitFlowTypesModel>('/ipad/children/visit-flow-types');
export default api;
